import '@ids/style-expandable-section';

import { Ui24ArrowSmDown } from '@ids/react-icons';

type ExpandableSectionProps = {
  title: string;
  children: React.ReactNode;
};

const ExpandableSection = ({ title, children }: ExpandableSectionProps) => {
  return (
    <details className="if expandable-section light">
      <summary className="if expandable-section-title" style={{ padding: '16px', minHeight: 'fit-content' }}>
        <span>{title}</span>
        <span className="if expandable-section-arrow align-items-center">
          <Ui24ArrowSmDown />
        </span>
      </summary>
      <div className="if expandable-section-content" style={{ padding: '0 16px 16px 16px' }}>
        {children}
      </div>
    </details>
  );
};

export default ExpandableSection;
